export const IMPRESSIONS = 'impressions';
export const VIEWS = 'views';
export const CLICKS = 'clicks';

export const RENAMED_GOALS = {
  [IMPRESSIONS]: 'Awareness',
  [VIEWS]: 'Consideration',
  [CLICKS]: 'Conversions',
};
